module.exports = __webpack_public_path__ + "static/img/pcbz2.8ae8d40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcbz2.jpg
// module id = lORf
// module chunks = 1